import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

type BoolColumnProps = {
  value: boolean;
  sortable?: boolean;
};

export const BoolColumn = (props: BoolColumnProps) => {
  const sx = props.sortable ? { ml: -3 } : undefined;

  return props.value ? (
    <CheckCircleIcon color='success' sx={sx} />
  ) : (
    <CancelIcon color='error' sx={sx} />
  );
};
